export const MENU_TEXT_COLOR = '#102342'
export const SWITCH_TO_TINYMCE_LABEL = 'Legacy editor'
export const SWITCH_TO_PROSEMIRROR_LABEL = 'New Simplero editor'
